// Should be generated by the backend?
// should we use the SupportedCountry from 'generated/graphql', same as the one in graphql?
export const SupportedCountries = ['NZ', 'AU', 'US'] as const;
export type SupportedCountry = (typeof SupportedCountries)[number];

export interface CountryInfo {
    shortName: string;
    name: string;
    domain: string;
}

export interface LocalisationData {
    locales: string[];
    timezone: string;
    country: SupportedCountry;
}
